import { useCallback } from "react";
import jwt_decode from "jwt-decode";

interface TokenPayload {
  name: string;
  role: string;
  sub: string;
  email: string;
  username: string;
}

export const useToken = () => {
  const getToken = useCallback((): string | undefined => {
    const value = `; ${document.cookie}`;
    const parts = value.split("; _auth.sit=");
    if (parts.length === 2) {
      return parts.pop()?.split(";").shift();
    }
    return undefined;
  }, []);

  const getTokenPayload = useCallback((): TokenPayload | null => {
    const token = getToken();
    if (!token) return null;

    try {
      return jwt_decode<TokenPayload>(token);
    } catch (error) {
      console.error("Erro ao decodificar o token:", error);
      return null;
    }
  }, [getToken]);

  return {
    getToken,
    getTokenPayload
  };
};
